import { Button, Modal } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import CostCenterExpenseBudgetReport from "~Features/pages/costCenters/costCenterDetails/costCenterExpenseBudgetReport"

interface ExpenseBudgetReportModalProps {
    costCenterId: string
    costCenterName: string
    budgetUsage: any
    isVisible: boolean
    onCancel: (state: boolean) => void
}

const ExpenseBudgetReportModal = ({ costCenterId, costCenterName, budgetUsage, isVisible, onCancel }: ExpenseBudgetReportModalProps) => {
    const { t } = useTranslation()

    return (
        <Modal
            open={isVisible}
            maskClosable={false}
            title={costCenterName}
            onCancel={() => onCancel(false)}
            className="ant-modal--small"
            destroyOnClose
            closable
            footer={[
                <Button key="back" onClick={() => onCancel(false)}>
                    {t("action:cancel")}
                </Button>,
            ]}
        >
            <CostCenterExpenseBudgetReport costCenterId={costCenterId} budgetUsage={budgetUsage} />
        </Modal>
    )
}

export default ExpenseBudgetReportModal
